(() => {
  const nativeAddSelector = '[data-add-to-cart], button[name="add"], button[type="submit"][name="add"]';
  const bundleAddSelector = '.gbbFooterNextButton, .gbbAddToCartButton, [class*="gbb"][class*="AddToCart"]';
  const removeSelector = 'cart-remove-button, .cart-product-remove, [data-cart-remove], [data-remove-item]';
  const triggerSelector = `${nativeAddSelector}, ${bundleAddSelector}`;
  const confettiColors = ['#6d8573', '#fffbef', '#f9b32e', '#b19090'];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let lastTrigger = null;
  let lastKnownCartCount = null;
  let bundleCheckToken = 0;
  let nativeCheckToken = 0;
  let nativeCelebratedToken = 0;
  let nativeAddPending = false;
  let nativePendingTimeout = null;
  let themeEventsConnected = false;

  const cartEndpoint = () => `${window.Shopify?.routes?.root || '/'}cart.js`;

  const getTriggerArea = (element) => {
    const rect = element.getBoundingClientRect();
    return {
      left: rect.left,
      top: rect.top,
      width: rect.width,
      height: rect.height,
    };
  };

  const rememberTrigger = (element) => {
    lastTrigger = { ...getTriggerArea(element), time: Date.now() };
  };

  const setBasketGlow = (count) => {
    document.querySelectorAll('.header--icon-item.cart').forEach((basket) => {
      basket.classList.toggle('novel-basket-has-items', Number(count) > 0);
    });
  };

  const bundleBannerMedia = window.matchMedia('(min-width: 768px)');

  const replaceBundleBanner = () => {
    if (!document.body.classList.contains('novel-bundle-page')) return;
    const bannerSource = bundleBannerMedia.matches
      ? document.body.dataset.novelBundleBannerDesktop
      : document.body.dataset.novelBundleBannerMobile;
    if (!bannerSource) return;

    const bannerElements = Array.from(document.querySelectorAll([
      'img.gbbBundleBanner',
      '.gbbBundleBanner img',
      'img[src*="1782516758677"]',
      'img[src*="1782516881003"]',
      '[style*="1782516758677"]',
      '[style*="1782516881003"]',
    ].join(',')));
    if (!bannerElements.length) return;

    const requestedBannerSource = new URL(bannerSource, document.baseURI).href;
    bannerElements.forEach((element) => {
      const banner = element.matches('img') ? element : element.querySelector('img');

      if (banner) {
        if (!banner.dataset.novelBundleOriginal) banner.dataset.novelBundleOriginal = banner.currentSrc || banner.src;
        if (banner.src !== requestedBannerSource || banner.hasAttribute('srcset')) {
          banner.src = bannerSource;
          banner.removeAttribute('srcset');
        }
        banner.closest('picture')?.querySelectorAll('source').forEach((source) => source.removeAttribute('srcset'));
        banner.alt = 'Bookwallet bundle highlights';
        banner.dataset.novelBundleApplied = requestedBannerSource;
        return;
      }

      const requestedBackground = `url("${requestedBannerSource}")`;
      if (element.style.backgroundImage !== requestedBackground) element.style.backgroundImage = requestedBackground;
      element.dataset.novelBundleApplied = requestedBannerSource;
    });
  };

  const fetchCartCount = async () => {
    const response = await fetch(cartEndpoint(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Unable to read basket');
    const cart = await response.json();
    lastKnownCartCount = Number(cart.item_count) || 0;
    setBasketGlow(lastKnownCartCount);
    return lastKnownCartCount;
  };

  const launchConfetti = (area) => {
    if (!area) return;
    for (let index = 0; index < 44; index += 1) {
      const piece = document.createElement('span');
      const angle = Math.random() * Math.PI * 2;
      const distance = 42 + Math.random() * 72;
      const originX = area.left + Math.random() * Math.max(area.width, 1);
      const originY = area.top + Math.random() * Math.max(area.height, 1);
      piece.className = 'novel-confetti-piece';
      piece.style.left = `${originX}px`;
      piece.style.top = `${originY}px`;
      piece.style.backgroundColor = confettiColors[index % confettiColors.length];
      piece.style.setProperty('--novel-confetti-x', `${Math.cos(angle) * distance}px`);
      piece.style.setProperty('--novel-confetti-y', `${Math.sin(angle) * distance + 58}px`);
      piece.style.setProperty('--novel-confetti-r', `${Math.round(Math.random() * 720 - 360)}deg`);
      piece.style.animationDelay = `${Math.random() * 80}ms`;
      document.body.appendChild(piece);
      window.setTimeout(() => piece.remove(), 1050);
    }
  };

  const launchSmoke = (element) => {
    if (!element) return;
    const item = element.closest('[id^="cart-product-item-"]');
    const rect = (item || element).getBoundingClientRect();
    const puff = document.createElement('span');
    puff.className = 'novel-smoke-puff';
    puff.style.left = `${rect.left + rect.width / 2}px`;
    puff.style.top = `${rect.top + rect.height / 2}px`;

    for (let index = 0; index < 10; index += 1) {
      const cloud = document.createElement('span');
      const angle = (Math.PI * 2 * index) / 10 + Math.random() * 0.35;
      const distance = 20 + Math.random() * 34;
      cloud.className = 'novel-smoke-puff__cloud';
      cloud.style.setProperty('--novel-smoke-size', `${18 + Math.random() * 18}px`);
      cloud.style.setProperty('--novel-smoke-x', `${Math.cos(angle) * distance}px`);
      cloud.style.setProperty('--novel-smoke-y', `${Math.sin(angle) * distance - 10}px`);
      cloud.style.setProperty('--novel-smoke-delay', `${Math.random() * 70}ms`);
      cloud.style.setProperty('--novel-smoke-color', index % 2 === 0 ? 'rgba(225, 221, 210, 0.86)' : 'rgba(151, 151, 143, 0.72)');
      puff.appendChild(cloud);
    }

    document.body.appendChild(puff);
    window.setTimeout(() => puff.remove(), 1000);
  };

  const confirmBundleAdd = async (startingCount, token, triggerPoint) => {
    for (let attempt = 0; attempt < 12; attempt += 1) {
      await new Promise((resolve) => window.setTimeout(resolve, 400));
      if (token !== bundleCheckToken) return;
      try {
        const count = await fetchCartCount();
        if (count > startingCount) {
          launchConfetti(triggerPoint);
          return;
        }
      } catch (error) {
        // A temporary cart request failure should not affect the bundle flow.
      }
    }
  };

  const celebrateNativeAdd = (token, triggerPoint) => {
    if (token <= nativeCelebratedToken) return;
    nativeCelebratedToken = token;
    launchConfetti(triggerPoint);
  };

  const confirmNativeAdd = async (startingCount, token, triggerPoint) => {
    for (let attempt = 0; attempt < 12; attempt += 1) {
      await new Promise((resolve) => window.setTimeout(resolve, 400));
      if (token !== nativeCheckToken) return;
      try {
        const count = await fetchCartCount();
        if (count > startingCount) {
          celebrateNativeAdd(token, triggerPoint);
          nativeAddPending = false;
          window.clearTimeout(nativePendingTimeout);
          return;
        }
      } catch (error) {
        // A temporary cart request failure should not suppress the celebration.
      }
    }
  };

  document.addEventListener('pointerdown', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest(triggerSelector);
    if (trigger) rememberTrigger(trigger);
  }, true);

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const removeTrigger = event.target.closest(removeSelector);
    if (removeTrigger) launchSmoke(removeTrigger);

    const trigger = event.target.closest(triggerSelector);
    if (!trigger) return;
    rememberTrigger(trigger);

    const isBundleAdd = trigger.matches(bundleAddSelector) || Boolean(trigger.closest(bundleAddSelector));
    if (isBundleAdd) {
      let startingCount = lastKnownCartCount;
      if (startingCount === null) {
        try {
          startingCount = await fetchCartCount();
        } catch (error) {
          return;
        }
      }
      bundleCheckToken += 1;
      confirmBundleAdd(startingCount, bundleCheckToken, lastTrigger);
    } else {
      nativeAddPending = true;
      nativeCheckToken += 1;
      const token = nativeCheckToken;
      const triggerPoint = lastTrigger;
      const startingCount = lastKnownCartCount;
      if (Number.isFinite(startingCount)) {
        confirmNativeAdd(startingCount, token, triggerPoint);
      }
      window.clearTimeout(nativePendingTimeout);
      nativePendingTimeout = window.setTimeout(() => {
        nativeAddPending = false;
      }, 10000);
    }
  }, true);

  const handleSuccessfulNativeAdd = () => {
    if (nativeAddPending && lastTrigger && Date.now() - lastTrigger.time < 10000) {
      celebrateNativeAdd(nativeCheckToken, lastTrigger);
    }
    nativeAddPending = false;
    window.clearTimeout(nativePendingTimeout);
    window.setTimeout(() => fetchCartCount().catch(() => {}), 120);
  };

  const handleNativeAddError = () => {
    nativeAddPending = false;
    nativeCheckToken += 1;
    window.clearTimeout(nativePendingTimeout);
  };

  const connectThemeEvents = () => {
    if (themeEventsConnected) return true;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, handleSuccessfulNativeAdd);
      subscribe(PUB_SUB_EVENTS.cart_error, handleNativeAddError);
      themeEventsConnected = true;
      return true;
    }
    return false;
  };

  const initializeTypewriters = (scope = document) => {
    scope.querySelectorAll('[data-novel-typewriter]:not([data-typewriter-initialized])').forEach((heading) => {
      const textElement = heading.querySelector('[data-novel-typewriter-text]');
      if (!textElement) return;
      heading.dataset.typewriterInitialized = 'true';

      const characters = Array.from(textElement.textContent || '');
      const speed = Math.max(20, Number(heading.dataset.typewriterSpeed) || 70);
      textElement.textContent = '';
      let characterIndex = 0;

      const typeNextCharacter = () => {
        textElement.textContent += characters[characterIndex] || '';
        characterIndex += 1;
        if (characterIndex < characters.length) {
          window.setTimeout(typeNextCharacter, speed);
        } else {
          heading.dataset.typewriterComplete = 'true';
        }
      };

      window.setTimeout(typeNextCharacter, speed);
    });
  };

  if (!connectThemeEvents()) {
    const eventConnectionTimer = window.setInterval(() => {
      if (connectThemeEvents()) window.clearInterval(eventConnectionTimer);
    }, 250);
    window.setTimeout(() => window.clearInterval(eventConnectionTimer), 15000);
    window.addEventListener('load', connectThemeEvents, { once: true });
  }
  if (document.body.classList.contains('novel-bundle-page')) {
    replaceBundleBanner();
    if (bundleBannerMedia.addEventListener) bundleBannerMedia.addEventListener('change', replaceBundleBanner);
    else bundleBannerMedia.addListener(replaceBundleBanner);
    const bundleBannerObserver = new MutationObserver(replaceBundleBanner);
    bundleBannerObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'style'],
    });
    const bundleBannerRetry = window.setInterval(replaceBundleBanner, 250);
    window.setTimeout(() => window.clearInterval(bundleBannerRetry), 15000);
  }
  initializeTypewriters();
  document.addEventListener('shopify:section:load', (event) => initializeTypewriters(event.target));
  fetchCartCount().catch(() => {});
})();
